<template>
  <div class="active">
    <van-cell-group>
      <div class="box">
        <span class="titlenum">01</span>
        <span class="titlename">出席人</span>
      </div>
      <van-field v-model="params.name" placeholder="填写出席人" @blur='checkName' />
    </van-cell-group>
    <van-cell-group>
      <div class="box">
        <span class="titlenum">02</span>
        <span class="titlename">媒体名称</span>
      </div>
      <van-field v-model="params.media_name" placeholder="填写媒体名称" />
    </van-cell-group>
    <van-cell-group>
      <div class="box">
        <span class="titlenum">03</span>
        <span class="titlename">联系方式(手机)</span>
      </div>
      <van-field v-model="params.mobile" type='tel' placeholder="填写联系方式" maxlength='11' @blur='checkMobile' />
    </van-cell-group>
    <van-cell-group>
      <div class="box">
        <span class="titlenum">04</span>
        <span class="titlename">家属是否随行</span>
      </div>
      <van-radio-group v-model="params.is_family">
        <van-radio name="1" checked-color="#605C6B">是</van-radio>
        <van-radio name="0" checked-color="#605C6B">否</van-radio>
      </van-radio-group>
    </van-cell-group>
    <van-cell-group>
      <div class="box">
        <span class="titlenum">05</span>
        <span class="titlename">家庭人数</span>
      </div>
      <van-field v-model="params.family_num" type='number' placeholder="填写家庭人数" />
    </van-cell-group>
    <van-cell-group>
      <div class="box">
        <span class="titlenum">06</span>
        <span class="titlename">家属是否有小孩</span>
      </div>
      <van-radio-group v-model="params.is_child">
        <van-radio name="1" checked-color="#605C6B">是</van-radio>
        <van-radio name="0" checked-color="#605C6B">否</van-radio>
      </van-radio-group>
    </van-cell-group>
    <van-cell-group>
      <div class="box">
        <span class="titlenum">07</span>
        <span class="titlename">儿童年龄</span>
      </div>
      <van-field v-model="params.child_age" type='number' placeholder="填写年龄" maxlength='2' />
    </van-cell-group>
    <van-cell-group>
      <div class="box">
        <span class="titlenum">08</span>
        <span class="titlename">住宿(是/否)</span>
      </div>
      <van-radio-group v-model="params.is_hotel">
        <van-radio name="1" checked-color="#605C6B">是</van-radio>
        <van-radio name="0" checked-color="#605C6B">否</van-radio>
      </van-radio-group>
    </van-cell-group>
    <van-cell-group>
      <div class="box">
        <span class="titlenum">09</span>
        <span class="titlename">住宿(标间/大床)</span>
      </div>
      <van-radio-group v-model="params.hotel_size">
        <van-radio name="1" checked-color="#605C6B">标间</van-radio>
        <van-radio name="0" checked-color="#605C6B">大床</van-radio>
      </van-radio-group>
    </van-cell-group>
    <van-cell-group>
      <div class="box">
        <span class="titlenum">10</span>
        <span class="titlename">住宿(标间/大床)</span>
      </div>
      <van-radio-group v-model="params.vehicle_type">
        <van-radio name="1" checked-color="#605C6B">自驾前往</van-radio>
        <van-radio name="0" checked-color="#605C6B">试驾车专车接送</van-radio>
      </van-radio-group>
    </van-cell-group>
    <van-cell-group class="mb-100">
      <div class="box">
        <span class="titlenum">11</span>
        <span class="titlename">其他需求(500字)</span>
      </div>
      <van-field
      v-model="params.other"
      rows="4"
      autosize
      type="textarea"
      maxlength="500"
      placeholder="填写需求"
      show-word-limit
      />
    </van-cell-group>
    <div class="btn-box">
      <van-button color="#605C6B" size="large" @click="saveInfo">确认提交</van-button>
    </div>
  </div>
</template>
<script>
  import active from '../../../api/lexus/active';
  import common from '../../../api/common';
  import {Field,Button,RadioGroup,Radio,Cell, CellGroup } from 'vant';
  export default {
    data () {
      return {
        params:{
          hid:'',
          name:'',
          media_name:'',
          mobile:'',
          is_family:'',
          family_num:'',
          is_child:'',
          child_age:'',
          is_hotel:'',
          hotel_size:'',
          vehicle_type:'',
          other:'',
        }
        
      }
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.params.hid = this.$route.params.id
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      checkMobile(){
        if(this.params.mobile==''){
          this.$toast('请填写手机号');
          return false
        }else if(!(/^1[3456789]\d{9}$/.test(this.params.mobile))){
          this.$toast('请填写正确的手机号');
          return false
        }
      },
      checkName(){
        if(this.params.name==''){
          this.$toast('请填写出席人');
          return false
        }
      },
      saveInfo(){
        if(this.params.name==''){
          this.$toast('请填写出席人');
          return false
        }else if(this.params.mobile==''){
          this.$toast('请填写手机号');
          return false
        }
        active.saveInfo(this.params).then(res => {
          this.$toast.success('报名成功');
          this.$router.replace({name: 'LexusMyCarAudit',params:{name:'活动报名'}})
        })
      }
    },
    components: {
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Field.name]:Field,
      [Button.name]:Button,
      [Cell.name]: Cell,
      [CellGroup.name]:CellGroup,
    }
  }
</script>
<style lang="scss">
.active{
  .van-cell-group{
    padding: 10px 0;
  }
  .box{
    margin-left: 15px;
    .titlenum{
      font-size: 20px;
      font-weight: bold;
      color: #3A3A3A;
    }
    .titlename{
      font-size: 12px;
      color: #3A3A3A;
      margin-left: 5px;
    }
  }
  .van-radio-group{
    display: flex;
    padding: 10px 15px;
  }
  .van-radio{
    margin-right: 40px;
    .van-radio__label{
      font-size: 14px;
    }
  }
  .btn-box{
    width: 100%;
    bottom: 20px;
    position: fixed;
    text-align: center;
    .van-button--large{
      width: 90%;
    }
  }
  .mb-100{
    margin-bottom: 100px;
  }
}
</style>
